import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { BakimTalebiEditComponent } from './bakim-talebi-edit.component';
import { BakimTalebiKartComponent } from './bakim-talebi-kart.component';
import { BakimTalebiKartSadeComponent } from './bakim-talebi-kart-sade.component';

@DinamikBilesen({
  id: 'bakim-talebi',
  baslik: 'Bakım Talebi',
  aciklama: 'Arıza ve bakım talebi',
  ikon: 'tool',
  kategori: 'personel',
})
class BakimTalebi {
  paylas_kutusu = BakimTalebiEditComponent;
  paylasilmis_kart = BakimTalebiKartComponent;
  paylasilmis_kart_sade = BakimTalebiKartSadeComponent;
  hesaplamalar = {
    pipeline: [
      { $match: { _uid: '{{kartId}}', silindi: { $ne: true } } },
      { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'icerikDetay' } },
      { $unwind: { path: '$icerikDetay', preserveNullAndEmptyArrays: false } },
      { $group: {
        _id: { $ifNull: ['$icerikDetay.ek.bilesen', '$icerikDetay.ek._secilenSetId'] },
        toplam: { $sum: 1 },
        sonDurum: { $last: '$icerikDetay.ek.durum' },
        sonTarih: { $last: '$tarih' },
        tamamlanan: { $sum: { $cond: [{ $eq: ['$icerikDetay.ek.durum', 'Tamamlandi'] }, 1, 0] } },
        toplamTutar: { $sum: { $toDouble: { $ifNull: ['$icerikDetay.ek.tutar', '0'] } } }
      }}
    ],
    prepipe: [
      { $lookup: { from: 'hareketler', let: { pid: '$_id' }, pipeline: [
        { $match: { $expr: { $eq: ['$_uid', '$$pid'] }, silindi: { $ne: true } } },
        { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'ic' } },
        { $unwind: { path: '$ic', preserveNullAndEmptyArrays: false } }
      ], as: '_alt' } },
      { $addFields: {
        '_hesap.toplamAltKart': { $size: '$_alt' },
        '_hesap.toplamGorev': { $size: { $filter: { input: '$_alt', cond: { $in: ['$$this.ic.ek.bilesen', ['gorev', 'bakim-gorev']] } } } },
        '_hesap.tamamlananGorev': { $size: { $filter: { input: '$_alt', cond: { $and: [{ $in: ['$$this.ic.ek.bilesen', ['gorev', 'bakim-gorev']] }, { $eq: ['$$this.ic.ek.tamamlandi', true] }] } } } },
        '_hesap.toplamMaliyet': { $sum: { $map: { input: { $filter: { input: '$_alt', cond: { $in: ['$$this.ic.ek.bilesen', ['maliyet-kalemi']] } } }, in: { $toDouble: { $ifNull: ['$$this.ic.ek.tutar', '0'] } } } } }
      }},
      { $project: { _alt: 0 } }
    ]
  };
}
